export const TheadDei = [
  { name: "Usuario calificado", order: null },
  { name: "Formulario", order: null },
  { name: "Código", order: null },
  { name: "Tipo de Operación", order: null },
  { name: "DEI", order: null },
];
